import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { Component, Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { isNotNullOrUndefined } from '@contact/upgrade';

import { default as componentAjs } from './agent-booking-mail-allocated.component.ajs';

@Directive({
  selector: 'cng-agent-booking-mail-allocated-upgrade',
})
export class AgentBookingMailAllocatedUpgradeComponent extends UpgradeComponent {
  @Input() responseId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super(componentAjs, elementRef, injector);
  }
}

@Component({
  selector: 'cng-agent-booking-mail-allocated',
  template: '<cng-agent-booking-mail-allocated-upgrade [responseId]="responseId$ | async"></cng-agent-booking-mail-allocated-upgrade>',
})
export class AgentBookingMailAllocatedComponent {
  readonly responseId$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.ResponseId.select).pipe(isNotNullOrUndefined());

  constructor(private readonly router: AgentDesktopRouter) {}
}
